import React, { useEffect, useState } from "react";
import axios from "axios";
import { differenceInDays, format } from "date-fns";
import { es } from "date-fns/locale";
import { toast } from "react-toastify";
import { BsPlus } from "react-icons/bs";
import {
  FaCheck,
  FaCheckCircle,
  FaExclamationTriangle,
  FaMicrophone,
  FaMinus,
  FaPlus,
  FaPlusCircle,
  FaQuestion,
  FaRegFilePdf,
  FaSave,
  FaSearch,
  FaUsers,
} from "react-icons/fa";

import { BACKEND } from "../../config/configEnvs";

import { BsClipboard2Check } from "react-icons/bs";
import { MdAutorenew, MdClose, MdDocumentScanner } from "react-icons/md";
import {
  getFinalPriceCot,
  getFinalPriceCotDrawer,
  getPuntosFromSelectedServicesandAllServices,
} from "../../helpers/pricesCotizacion";
import AgregarServicio from "../cotizaciones/AgregarServicio";
import ItemRowServicioCotizacion from "../cotizaciones/ItemRowServicioCotizacion";
import ItemRowPagoCotizacion from "../cotizaciones/ItemRowPagoCotizacion";
import AgregarPago from "../cotizaciones/AgregarPago";
import Tooltip from "../ui/ToolTip";

import NuevoClienteDialog from "../dialogs/NuevoClienteDialog";
import CotizacionPDFDialog from "../dialogs/CotizacionPDFDialog";
import DrawerRight from "../ui/DrawerRight";
import CotizacionPDFTestV2 from "../dialogs/CotizacionPDFTestV2";
import { FormatDateToDDMMYY } from "../../utils/FormatDate";
import ObtenerMultiplicador from "../../utils/preciosPaises/obtenerMultiplicador";
import NormalizeText from "../../utils/normalizeValues/NormalizeText";
import ObtenerMoneda from "../../utils/preciosPaises/ObtenerMoneda";
import { FaPerson } from "react-icons/fa6";

const DrawerCotizacionCalendarioPagosDetails = ({
  onClose,
  open,
  dataDrawer,
  refetch,
  isAdmin,
  paises,
  currencyExchanges
}) => {
  const [allPlanesList, setAllPlanesList] = useState([]);
  const [openAddServicio, setOpenAddServicio] = useState(false);
  const [openAddPago, setOpenAddPago] = useState(false);
  const [allServiciosList, setAllServiciosList] = useState([]);
  const [allClientesUserList, setAllClientesUserList] = useState([]);
  const [allServiciosCotizacionesList, setAllServiciosCotizacionesList] = useState([]);
  const [convertToFacturaActive, setConvertToFacturaActive] = useState(false);
  const [searchInputClientes, setSearchInputClientes] = useState("");
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [createNewClientActive, setCreateNewClientActive] = useState(false);
  const [isCopiedId, setIsCopiedId] = useState(false);

  const [data, setData] = useState(null);

  const [estadoCotizacion, setEstadoCotizacion] = useState("");
  const [tipoCotizacion, setTipoCotizacion] = useState("");
  const [serviciosList, setServiciosList] = useState([]);
  const [pagosList, setPagosList] = useState([]);
  const [isDescuento, setIsDescuento] = useState(false);
  const [precioDescuento, setPrecioDescuento] = useState(0);
  const [tipoDescuento, setTipoDescuento] = useState("fijo"); //fijo - porcentaje
  const [isDescuentoOpen, setIsDescuentoOpen] = useState(false);
  const [igv, setIgv] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);

  const multiplicador = ObtenerMultiplicador({pais: data?.cliente?.pais || data?.lead?.country, paises: paises})
  const flagUrl = paises.find(p => NormalizeText(p.name) === NormalizeText(data?.cliente?.pais || data?.lead?.country))?.bandera?.url
  const currency = ObtenerMoneda({pais: data?.cliente?.pais || data?.lead?.country, paises: paises})
  const currencyExchange = currencyExchanges[currency]

  const allowUniquePayment = allServiciosCotizacionesList.some(s => s.servicio.tipoPago === "Mensual")

  const { subtotalSinIGV, igvTotal, totalConIGV } = getFinalPriceCotDrawer({
    serviciosCotizaciones: allServiciosCotizacionesList,
    allServiciosList: allServiciosList,
    porcentajeIGV: 18,
    multiplicador: multiplicador
  })

  const hostingDomainCot = allServiciosCotizacionesList.some(servicio => 
    servicio.servicio.id === "66c465aa5d02f2a631e4708c" ||
    servicio.servicio.id === "66c474b95d02f2a631e470a2" || 
    servicio.servicio.id === "66c475035d02f2a631e470ad" ||
    servicio.servicio.id === "66c474755d02f2a631e47097"
  )

  const getServicios = async () => {
    await axios
      .get(`${BACKEND}/api/servicios?limit=1000`)
      .then(({ data }) => setAllServiciosList(data.docs))
      .catch((e) => console.log(e));
  };

  const getInitialClientesWithQuery = async () => {
    await axios
      .get(
        `${BACKEND}/api/clientesUser?where[nombreComercial][like]=${searchInputClientes}`
      )
      .then(({ data }) => setAllClientesUserList(data.docs))
      .catch((e) => console.log(e));
  };

  const getInitialClientesWithQueryOnRefresh = async () => {
    await axios
      .get(`${BACKEND}/api/clientesUser`)
      .then(({ data }) => setAllClientesUserList(data.docs))
      .catch((e) => console.log(e));
  };

  const getSubmitClientes = async (event) => {
    event.preventDefault();
    await getInitialClientesWithQuery();
  };

  const convertToFactura = async () => {
    if (puntosList.length === 0) {
      await axios
        .post(`${BACKEND}/api/puntosServicioCliente`, {
          cotizacion: data?.id,
          cliente: selectedCliente?.id,
          puntos: 0,
        })
        .then(({ data }) => setPuntosList([data.doc]))
        .catch((e) => console.log(e));
    }

    try {
      const responseCotizacion = await axios.put(
        `${BACKEND}/api/cotizaciones/${data?.id}`,
        {
          cliente: selectedCliente?.id,
          tipo: "Factura",
          estado: "Exito",
        }
      );

      setTipoCotizacion(responseCotizacion.data.doc.tipo);
      setData((prev) => ({
        ...prev,
        cliente: responseCotizacion.data.doc.cliente,
      }));
      setEstadoCotizacion("Exito");
      setTipoCotizacion("Factura");
      setConvertToFacturaActive(false);
      toast.success("Convertido a factura exitosamente", {
        style: { zIndex: 9999 },
        position: "top-right",
      });
    } catch (error) {
      toast.success("Error al convertir a factura, intente nuevamente", {
        style: { zIndex: 9999 },
      });
    }
  };

  const getServiciosCotizaciones = async () => {
    await axios
      .get(
        `${BACKEND}/api/serviciosCotizaciones?where[cotizacion][equals]=${dataDrawer?.id}`
      )
      .then(({ data }) => setAllServiciosCotizacionesList(data.docs))
      .catch((e) => console.log(e));
  };

  const getPlanes = async () => {
    await axios
      .get(`${BACKEND}/api/planes?limit=0`)
      .then(({ data }) => setAllPlanesList(data.docs))
      .catch((e) => console.log(e));
  };
  const [puntosList, setPuntosList] = useState([]);

  const getCurrentPoints = async () => {
    if (data && data?.cliente) {
      await axios
        .get(
          `${BACKEND}/api/puntosServicioCliente?where[cliente][equals]=${data.cliente.id}&where[cotizacion][equals]=${dataDrawer.id}`
        )
        .then(({ data }) => setPuntosList(data.docs))
        .catch((e) => console.log(e));
    }
  };

  const getPagos = async () => {
    await axios
      .get(
        `${BACKEND}/api/pagosCotizaciones?where[cotizacion][equals]=${dataDrawer.id}&sort=createdAt&limit=0`
      )
      .then(({ data }) => setPagosList(data.docs))
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    getServicios();
    getPlanes();
  }, []);

  useEffect(() => {
    if (dataDrawer) getServiciosCotizaciones();
    if (dataDrawer) getCurrentPoints();
    if (dataDrawer) getPagos();
  }, [dataDrawer]);

  useEffect(() => {
    if (dataDrawer) setData(dataDrawer);

    if (
      dataDrawer?.descuento &&
      dataDrawer?.precioDescuento &&
      dataDrawer?.tipoDescuento
    ) {
      setIsDescuento(true);
      setIsDescuentoOpen(true);
      setPrecioDescuento(dataDrawer?.precioDescuento);
      setTipoDescuento(dataDrawer?.tipoDescuento);
    } else {
      setIsDescuentoOpen(false);
      setPrecioDescuento(0);
    }
    if (dataDrawer) {
      setEstadoCotizacion(
        dataDrawer?.estado
          ? dataDrawer?.estado
          : dataDrawer?.totalPagado === dataDrawer.precioTotal
          ? "Exito"
          : "En espera"
      );
      setTipoCotizacion(dataDrawer.tipo);

      if (dataDrawer?.igv) {
        setIgv(true);
      } else {
        setIgv(false);
      }
    }
  }, [dataDrawer]);

  if (!data) return;

  const itemsDataArray = [
    // { id: 1, title: "Pais", content: data?.cliente?.pais },
    { id: 2, title: "Nombre Gerente", content: data?.cliente?.nombreGerente },
    { id: 3, title: "Razón social", content: data?.cliente?.razonSocial },
    {
      id: 4,
      title: "Cumpleaños gerente",
      content: data?.cliente?.cumpleaniosGerente
        ? format(new Date(data.cliente.cumpleaniosGerente), "dd MMMM, yyyy", {
            locale: es,
          })
        : "No registrado",
    },
    { id: 5, title: "RUC", content: data?.cliente?.ruc },
    {
      id: 6,
      title: "Teléfono Gerente",
      content: data?.cliente?.telefonoGerente,
    },
    {
      id: 7,
      title: "Correo electrónico gerencia",
      content: data?.cliente?.emailGerencia,
    },
    {
      id: 8,
      title: "Fecha Aniversario",
      content: data?.cliente?.fechaAniversario
        ? format(new Date(data.cliente?.fechaAniversario), "dd MMMM, yyyy", {
            locale: es,
          })
        : "No registrado",
    },
    {
      id: 9,
      title: "Encargado del proyecto",
      content: data?.cliente?.encargadoProyecto,
    },
    { id: 10, title: "Direccion", content: data?.cliente?.direccion },

    { id: 11, title: "N° empleados", content: data?.cliente?.nEmpleados },
    { id: 12, title: "Teléfono", content: data?.cliente?.telefono },
    { id: 13, title: "Rubro", content: data?.cliente?.rubro },

    {
      id: 14,
      title: "Fecha cumpleaños",
      content: data?.cliente?.fechaCumpleanios
        ? format(new Date(data.cliente?.fechaCumpleanios), "dd MMMM, yyyy", {
            locale: es,
          })
        : "No registrado",
    },
    {
      id: 15,
      title: "Ingresos anuales",
      content: data?.cliente?.ingresosAnuales,
    },
    {
      id: 16,
      title: "Puesto de trabajo",
      content: data?.cliente?.puestoTrabajo,
    },
  ];

  const saveAll = async () => {
    if (puntosList.length > 0 && tipoCotizacion === "Factura") {
      await axios
        .put(`${BACKEND}/api/puntosServicioCliente/${puntosList[0].id}`, {
          puntos: getPuntosFromSelectedServicesandAllServices(
            allServiciosCotizacionesList,
            allServiciosList
          ),
        })
        .then(({ data }) => setPuntosList([data.doc]))
        .catch((e) => console.log(e));
    }
    await axios
      .put(`${BACKEND}/api/cotizaciones/${data?.id}`, {
        estado: estadoCotizacion,
        tipo: estadoCotizacion === "Exito" ? "Factura" : "Cotizacion",
        precioTotal: getFinalPriceCot(
          allServiciosCotizacionesList,
          isDescuento
            ? tipoDescuento === "fijo"
              ? precioDescuento
              : (getFinalPriceCot(
                  allServiciosCotizacionesList,
                  0,
                  allServiciosList
                ) *
                  precioDescuento) /
                100
            : 0,
          allServiciosList
        ),
        descuento: isDescuento,
        tipoDescuento: tipoDescuento,
        precioDescuento: precioDescuento,
        igv: igv,
      })
      // .then(async()=>await refetch())
     

      .then(() =>
        toast.success("Cotización actualizada exitosamente", {
          style: { zIndex: 9999 },
          position: "top-right",
        })
      )
      .then(async()=>await refetch())
      .catch((e) => {
        toast.error("Error al actualizar la cotizacion", {
          style: { zIndex: 9999 },
        });
        console.log(e);
      });
  };


  const copyIdClipBoard = () => {
    navigator.clipboard.writeText(data.id);
    setIsCopiedId(true);
  };

  const closeDrawer = () => {
    onClose();
    setIsCopiedId(false);
  };

  const type = "calendarioPagos"

  return (
    <DrawerRight
      open={open}
      //maxWidth={1600}
      maxWidth={"100%"}
      title={`✅ ${data?.cliente?.nombreComercial || data?.lead?.leadName} 🙋🏻‍♀️ Vendedor: ${data?.cotizador?.name}  🤑  Total: S/. ${data?.precioTotal?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 📁 Servicios: ${allServiciosCotizacionesList.map(servicio => servicio.servicio?.name).filter(Boolean).join(", ")}`}
      onClose={closeDrawer}
    >
      
      {/* Header */}
      <div className="flex flex-col sticky top-16 z-30">
        
        {/* Id de cot y fuente lead */}
        <div className="p-1 my-1 shadow-md flex flex-col justify-between items-center justify-center gap-4 border border-gray-200 rounded-md bg-white/60 backdrop-blur-md">

          {/* Fuente lead y tipo lead*/}
          <div className="flex flex-row gap-4 items-center justify-between w-full">

            {/* Fuente lead */}
            <div className="p-2 text-xs rounded-lg bg-white border">
              <dt className="font-bold text-xs leading-none text-gray-600">
                Fuente Lead:{" "}
                <span className="text-xs">{data.lead?.leadOrigin || data.fuenteLead} </span>
              </dt>
            </div>

            {/* Tipo cotizacion */}
            <div className="p-2 text-xs rounded-lg bg-white border">
              <dt className="font-bold text-xs leading-none text-gray-600">
                Tipo:{" "}
                <span className="text-xs">{data.tipo} </span>
              </dt>
            </div>

            {/* Id */}
            <div className="0 flex justify-start gap-2 items-center text-gray-700">
              <dt className="  text-xs leading-none  ">
                <strong>{data.id} </strong>
              </dt>
              {isCopiedId ? (
                <Tooltip
                  content={<div className=" text-xs text-green-600"> Copiado</div>}
                  theme="light"
                >
                  <div className=" bg-gray-50 rounded-sm p-2">
                    <FaCheck className=" text-green-500 w-5 h-5" />
                  </div>
                </Tooltip>
              ) : (
                <Tooltip
                  content={<div className=" text-xs">Copiar ID</div>}
                  theme="light"
                >
                  <div
                    onClick={copyIdClipBoard}
                    className=" cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-md p-2"
                  >
                    <BsClipboard2Check className=" text-gray-700 w-5 h-5" />
                  </div>
                </Tooltip>
              )}
            </div>
            
            {/* Empresa */}
            <div className="flex flex-col justify-end h-full items-end">
              <div className="flex flex-row gap-2 items-center">
                <span className="text-xs font-bold">Empresa: </span>
                <span className="text-xs">{data.empresa?.razonSocial}</span>
              </div>
            </div>

            {/* Marca seleccionada*/}
            <div className="flex flex-col gap-4 items-end">
              <div className="flex gap-2 justify-end items-center text-gray-700">
                {(() => {
                  const url = data.marca?.image?.url
                  return (
                    url ? (
                        <img src={url} alt={data.marca?.name || "Marca"} className="w-8"/>
                    ) : (
                      <div className="w-8">
                      </div>
                    )
                  )
                })()}
                <span className="text-xs font-bold">Marca: </span>
                <span className="text-xs">{data.marca?.name}</span>
              </div>
            </div>


          </div>
        
        </div>
        
        {/* Asesor comercial, cliente, estado cotizacion + tipo factura (compacto) */}
        <div className="sticky top-0 bg-slate-50/60 backdrop-blur-md p-3 border border-gray-200 rounded-md shadow-md">
          <div className="grid grid-cols-12 gap-3 items-center">

            {/* Primera fila: Asesor, Responsable de venta, Estado cotización y Subestado */}
            <div className="col-span-12 md:col-span-12 flex flex-wrap items-center justify-between gap-3">
              {/* Asesor */}
              <div className="col-span-12 md:col-span-3 flex items-center gap-2">
                <span className="text-[10px] font-semibold">Asesor:</span>
                {data?.cotizador?.foto ? (
                  <>
                    <img
                      alt="cotizador"
                      className="w-6 h-6 object-cover rounded-full"
                      src={data?.cotizador?.foto?.url}
                    />
                    <span className="text-xs">{data?.cotizador?.name}</span>
                  </>
                ) : (
                  <span className="text-xs">{data?.cotizador?.name}</span>
                )}
              </div>
    
              {/* Responsable de venta */}
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-semibold">Responsable:</span>
                <span className="text-xs">{data?.responsableVenta || "No definido"}</span>
              </div>
              
              {/* Estado cotización */}
              <div className="col-span-6 md:col-span-2">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-semibold">Estado:</span>
                  <span className="text-xs">{data?.estado || "No definido"}</span>
                </div>
              </div>

              {/* Subestado */}
              <div className="col-span-6 md:col-span-4">
                <div className="flex items-center gap-2 min-w-[500px] max-w-[500px]">
                  <span className="text-[10px] font-semibold">Subestado:</span>
                  <span className="text-xs">{data?.subEstado || "No definido"}</span>
                </div>
              </div>
            </div>

            {/* Segunda fila: Responsable, Fecha venta, Primera cotización y Comentario */}
            <div className="col-span-12 md:col-span-12 flex flex-wrap items-center justify-between gap-3">
              {/* Cliente o Lead */}
              <div className="col-span-12 md:col-span-3 flex items-center gap-2">
                <span className="text-[10px] font-semibold">
                  {data?.cliente ? "Cliente:" : data?.lead ? "Lead:" : "Cliente:"}
                </span>
                <span className="text-xs">
                  {data?.cliente ? data?.cliente?.nombreComercial : data?.lead ? data?.lead?.leadName : "-"}
                </span>
              </div>

              {/* Fecha venta (solo Exito) */}
              {data.estado === "Exito" && (
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-semibold">Fecha venta:</span>
                  <span className="text-xs">{data.fechaVenta ? FormatDateToDDMMYY(data.fechaVenta) : "-"}</span>
                </div>
              )}

              {/* Primera cotización */}
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-semibold">¿Primera cotización?</span>
                <input
                  type="checkbox"
                  className="rounded-sm border-gray-400 hover:cursor-pointer"
                  checked={data?.primeraCotizacion}
                  disabled={true}
                />
              </div>

              {/* Comentario - Ocupa el espacio restante */}
              <div className="flex items-center gap-2 flex-1 min-w-[200px] max-w-[500px]">
                <span className="text-[10px] font-semibold whitespace-nowrap">Comentario:</span>
                <span className="text-xs">{data?.comentario || "No definido"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Si no hay cliente registrado y la cotizacion pasa a éxito, se pide que se registren los datos del cliente */}
      <div>
        {tipoCotizacion === "Cotizacion" &&
          convertToFacturaActive &&
          !data?.cliente && (
            <div className="px-2 py-2 rounded-md bg-gray-200">
              <div className="flex justify-end pb-4">
                <div
                  onClick={() => {
                    setConvertToFacturaActive(false);
                    setEstadoCotizacion("En espera");
                  }}
                  className="p-2 bg-blue-50 rounded-lg cursor-pointer "
                >
                  <MdClose className=" text-blue-600" />
                </div>
              </div>

              <div className=" max-w-md mx-auto w-full">
                <NuevoClienteDialog
                  onSuccess={() => getInitialClientesWithQueryOnRefresh()}
                  open={createNewClientActive}
                  title={"Nuevo Cliente"}
                  onClose={() => setCreateNewClientActive(false)}
                />

                <div>
                  <div className=" mx-auto">
                    <h3 className=" text-gray-800 text-base pb-4 text-xs font-semibold">
                      Seleccionar un cliente
                    </h3>

                    <form
                      onSubmit={getSubmitClientes}
                      className=" pb-4 mx-auto"
                    >
                      <label
                        htmlFor="default-search"
                        className="mb-2 text-xs font-medium sr-only text-gray-700"
                      >
                        Search
                      </label>
                      <div className="relative max-w-md ">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                          <FaSearch className=" text-gray-600" />
                        </div>
                        <input
                          type="search"
                          id="default-search"
                          value={searchInputClientes}
                          onChange={(e) =>
                            setSearchInputClientes(e.target.value)
                          }
                          className="block w-full p-4 ps-10 text-xs  border 0 rounded-lg   bg-gray-100 border-gray-300 placeholder-gray-700 text-black "
                          placeholder="Buscar clientes "
                          required
                        />
                        <button
                          type="submit"
                          className="text-white absolute end-2.5 bottom-2.5 focus:ring-4 focus:outline-none font-medium rounded-lg text-xs px-4 py-2 bg-blue-600 hover:bg-blue-700 focus:ring-blue-800"
                        >
                          Buscar
                        </button>
                      </div>
                    </form>
                  </div>

                  <div className=" w-full   grid grid-cols-1 gap-2 md:grid-cols-2">
                    {allClientesUserList.map((e) => (
                      <button
                        onClick={() => setSelectedCliente(e)}
                        className={` ${
                          selectedCliente?.id === e.id
                            ? "bg-blue-500 text-white"
                            : "bg-white text-gray-700 hover:bg-blue-50"
                        } p-2 flex flex-col justify-start text-xs rounded-md  `}
                        key={e.id}
                      >
                        <span className=" text-base font-semibold text-xs ">
                          {" "}
                          {e.nombreComercial}
                        </span>
                        <span className=" text-xs font-light "> {e.email}</span>
                      </button>
                    ))}

                    {!createNewClientActive && (
                      <button
                        onClick={() => setCreateNewClientActive(true)}
                        type="button"
                        className=" px-2 py-3 flex flex-col justify-center items-center   rounded-md  text-white bg-blue-900 hover:bg-blue-800"
                      >
                        <FaPlusCircle />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className=" pb-4 pt-10 flex justify-center">
                <button
                  type="button"
                  disabled={!selectedCliente}
                  onClick={convertToFactura}
                  className="text-white bg-[#4285F4] hover:bg-[#4285F4]/90 text-xs focus:ring-4 cursor-pointer focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg px-5 py-2.5 text-center inline-flex gap-4 items-center focus:ring-gray-500  me-2 mb-2"
                >
                  Guardar estado y convertir a factura
                  <MdDocumentScanner className="w-6 h-6" />
                </button>
              </div>
            </div>
          )}
      </div>

      {/* Datos de la cotización */}
      <div className=" mt-4 mb-10">
        <dt className="mt-5 mb-2 font-semibold leading-none  text-black">
          Cotización
        </dt>

        <div className="flex flex-col gap-2 sm:grid sm:grid-cols-2">
          <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
            <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
              N° Cotización
            </dt>
            <dd className=" text-xs text-gray-600">{data?.numeroCotizacion}</dd>
          </div>

          <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
            <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
              Cotización válido hasta
            </dt>
            <dd className=" text-xs text-gray-600">
              {data?.fechaCotizacionLimite
                ? format(
                    new Date(data?.fechaCotizacionLimite),
                    "dd MMMM, yyyy",
                    { locale: es }
                  )
                : "No registrado"}
            </dd>
          </div>
        </div>

        {estadoCotizacion !== "Exito" && (
          <div className="flex flex-col mt-4 gap-2 sm:grid sm:grid-cols-2">
            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                DNI
              </dt>
              <dd className=" text-xs text-gray-600">{data?.lead?.DNI || "No definido"}</dd>
            </div>

            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                Nombres
              </dt>
              <dd className=" text-xs text-gray-600">{data?.leadNombre || "No definido"}</dd>
            </div>
          </div>
        )}

        {estadoCotizacion!== "Exito" && (
          <div className="flex flex-col mt-4 gap-2 sm:grid sm:grid-cols-2">
            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                RUC
              </dt>
              <dd className=" text-xs text-gray-600">{data?.leadRUC || "No definido"}</dd>
            </div>

            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                Nombre Legal
              </dt>
              <dd className=" text-xs text-gray-600">{data?.leadCompany || "No definido"}</dd>
            </div>
          </div>
        )}

        <div className="flex flex-col mt-4 gap-2 sm:grid sm:grid-cols-2">
          <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
            <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
              País
            </dt>
       
            <div className="flex flex-row items-center gap-2">
              <dd className="text-xs text-gray-600">{data?.lead?.country || data?.cliente?.pais}</dd>
              {flagUrl && (
                <img src={flagUrl} alt="Flag" className="w-4 h-4" />
              )}
            </div>
         
          </div>
        </div>

      </div>

      {/* Datos Cliente */}
      {data?.cliente && (
        <div>
          <dt className="mt-5 mb-2 font-semibold leading-none  text-black">
            Datos Generales del cliente
          </dt>
          <div className=" flex flex-col gap-2 sm:grid sm:grid-cols-2 md:grid md:grid-cols-3 ">
            {itemsDataArray?.map((e) => (
              <Item title={e.title} key={e.id}>
                {e.content}
              </Item>
            ))}
          </div>
        </div>
      )}

      <hr className="mt-8 mb-8"/>

      {/* Agregar servicios */}
      <div>
        <div className="mb-6 flex flex-row justify-between items-center">
          <h1 className="font-semibold leading-none text-sm text-black">
            Servicios de interés
          </h1>
        </div>
      </div>
      
      {/* Lista de servicios */}
      <div className="relative overflow-x-auto">
        <table className="w-full text-xs text-left rtl:text-right text-gray-500">
          <thead className="text-xs text-gray-700 bg-slate-100">
            <tr>
              <th scope="col" className="px-6 py-2">
                ID
              </th>
              {estadoCotizacion === "Exito" && (
                <th scope="col" className="px-6 py-2">
                  Requiere prod. audiovisual
                </th>
              )}
              <th scope="col" className="px-6 py-2 whitespace-nowrap">
                <Tooltip content="Advertencias">
                  <div className="flex">
                    <FaExclamationTriangle className="text-xs" />
                  </div>
                </Tooltip>
              </th>
              <th scope="col" className="px-6 py-2">
                <Tooltip content="Participantes">
                  <div className="flex">
                    <FaUsers className="text-xs" />
                  </div>
                </Tooltip>
              </th>
              <th scope="col" className="px-6 py-2">
                Editar {<br />} descripción
              </th>
              <th scope="col" className="px-6 py-2 whitespace-nowrap">
                Cuenta comercial o publicitaria
              </th>
              <th scope="col" className="px-6 py-2">
                Servicio
              </th>
              <th scope="col" className="px-6 py-2">
                Plan
              </th>
              <th scope="col" className="px-6 py-2">
                Comentario vendedor
              </th>
              <th scope="col" className="px-6 py-2">
                Audios
              </th>
              <th scope="col" className="px-6 py-2">
                Cantidad/<br />Meses
              </th>
              <th scope="col" className="px-6 py-2">
                Precio Unitario (PEN)
              </th>
              <th scope="col" className="px-6 py-2 whitespace-nowrap text-ellipsis">
                Editar <br /> Precio unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Tipo descuento unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Monto descuento unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Subtotal unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Subtotal
              </th>
              <th scope="col" className="px-6 py-2">
                IGV
              </th>
              <th scope="col" className="px-6 py-2">
                Monto IGV unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Monto IGV total
              </th>
              {allowUniquePayment && (
                <th scope="col" className="px-6 py-2">
                  Pago único
                </th>
              )}
              <th scope="col" className="px-6 py-2">
                Servicio gratuito (regalo)
              </th>
              <th scope="col" className="px-6 py-2 w-56">
                Fecha Tentativa Inicio
              </th>
              <th scope="col" className="px-6 py-2">
                Fecha Tentativa Fin
              </th>
              <th scope="col" className="px-6 py-2">
                Precio venta unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Previo venta final
              </th>
            </tr>
          </thead>
          <tbody>
            {allServiciosCotizacionesList.map((e) => (
              <ItemRowServicioCotizacion
                key={e.id}
                data={e}
                tipoCotizacion={tipoCotizacion}
                servicios={allServiciosList}
                allServiciosCotizacionesList={allServiciosCotizacionesList}
                setAllServiciosCotizacionesList={
                  setAllServiciosCotizacionesList
                }
                type={type}
                planes={allPlanesList}
                paises={paises}
                allowUniquePayment={allowUniquePayment}
              />
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Total */} 
      <div className="flex flex-col justify-end">
        {/* Subtotal sin IGV */}
        <div className="flex justify-end">
          <div className="bg-gray-50 shadow-md text-black p-2 text-sm">
            Subtotal:{" "}
            <strong>{data.moneda} {subtotalSinIGV.toFixed(2)}</strong>
          </div>
        </div>

        {/* Total IGV */}
        <div className="flex justify-end">
          <div className="bg-gray-50 shadow-md text-black p-2 text-sm">
            IGV:{" "}
            <strong>{data.moneda} {igvTotal.toFixed(2)}</strong>
          </div>
        </div>

        {/* Total con IGV y descuento */}
        <div className="flex justify-end">
          <div className="bg-gray-50 shadow-md text-black p-2 text-sm">
            Total:{" "}
            <strong>{data.moneda} {(totalConIGV).toFixed(2)}</strong>
          </div>
        </div>
      </div>
      
      {/* Transaccions si es Factura */}
      {tipoCotizacion === "Factura" && (
        <div className="mt-12 mb-6">
          {pagosList.length > 0 && (
            <h1 className="mt-5 mb-2 font-semibold leading-none text-sm text-black">
              Transacciones
            </h1>
          )}

          {pagosList && pagosList.length > 0 && (
            <div className="flex flex-col gap-4">
              <div className="border-t border-gray-500 pt-2 grid grid-cols-1 md:grid-cols-4 gap-2">
                <ItemTransaccion title={"Moneda"}>
                  {data.moneda}
                </ItemTransaccion>
                <ItemTransaccion title={"Cantidad adelanto reserva"}>
                  S/. {pagosList[0].precio.toFixed(2)}
                </ItemTransaccion>
                <ItemTransaccion title={"Fecha limite"}>
                  {pagosList[0].fechaLimite &&
                    format(
                      new Date(pagosList[0].fechaLimite),
                      "dd MMMM, yyyy",
                      { locale: es }
                    )}
                </ItemTransaccion>
              </div>

              <div className="border-t border-gray-500 pt-2 grid grid-cols-1 md:grid-cols-4 gap-2">
                <ItemTransaccion title={"Cantidad pagado"}>
                  S/. {pagosList.reduce((acc, obj) => acc + obj?.precio, 0).toFixed(2)}
                </ItemTransaccion>
                <ItemTransaccion title={"Porcentaje pagado"}>
                  {(pagosList.filter((p) => p.pagado).reduce((acc, obj) => acc + (obj.precio / totalConIGV * 100), 0).toFixed(2))}%
                </ItemTransaccion>
                <ItemTransaccion title={"Cuotas"}>
                  {pagosList.filter((p) => p.pagado).length}
                </ItemTransaccion>
              </div>

              <div className=" border-b border-t border-gray-500 py-2 grid grid-cols-1 md:grid-cols-4 gap-2">
                <ItemTransaccion title={"Cantidad Deuda"}>
                  S/. {(pagosList.filter((p) => !p.pagado).reduce((acc, obj) => acc + (obj.precio), 0).toFixed(2))}
                </ItemTransaccion>
                <ItemTransaccion title={"Porcentaje deuda"}>
                  {(pagosList.filter((p) => !p.pagado).reduce((acc, obj) => acc + (obj.precio / totalConIGV * 100), 0).toFixed(2))}%
                </ItemTransaccion>
                <ItemTransaccion title={"Cuotas"}>
                  {pagosList.filter((p) => !p.pagado).length}
                </ItemTransaccion>
              </div>
            </div>
          )}
        </div>
      )}

      <hr className="mt-8 mb-8"/>

      {/* Pago */}
      <div>
        <div className=" mb-6">
          <h1 className=" mt-5 mb-2 font-semibold leading-none  text-black">
            Condiciones de pago
          </h1>
        </div>
        <AgregarPago
          idCotizacion={data?.id}
          moneda={data.moneda}
          precioTotal={totalConIGV}
          pagosList={pagosList}
          setPagosList={setPagosList}
          open={openAddPago}
          onClose={() => setOpenAddPago(false)}
        />
      </div>
      
      {/* Lista de pagos */}
      <div className="relative overflow-x-auto">
        <table className="w-full text-xs text-left rtl:text-right text-gray-400">
          <thead className="text-xs text-gray-700 bg-slate-100">
            <tr>
              {/* {isAdmin && (
                <th scope="col" className="px-6 py-2"></th>
              )} */}
              <th scope="col" className="px-6 py-3 sticky z-[5] left-0 bg-slate-100 min-w-[60px] w-[60px] max-w-[60px]">
                <Tooltip content="Guardar">
                  <div className="flex pl-1">
                    <FaSave className="text-[10px]" />
                  </div>
                </Tooltip>
              </th>
              <th scope="col" className="px-6 py-3">
                Código
              </th>
              <th scope="col" className="px-6 py-3">
                Moneda
              </th>
              <th
                scope="col"
                className="px-6 py-3 sticky z-[5] bg-slate-100 left-[60px]"
                style={{ minWidth: "100px", width: "100px" }}
              >
                Descripción
              </th>
              <th
                scope="col"
                className="px-2 py-2 sticky z-[5] bg-slate-100 left-[160px]"
                style={{ minWidth: "500px", width: "500px" }}
              >
                <span className="flex flex-row items-center justify-center gap-4">
                  Distribución por servicio
                  <Tooltip content="Muestra cómo se distribuye el pago entre los diferentes servicios. Cada servicio puede tener un monto específico y puede incluir o no IGV.">
                    <div className="bg-black text-white rounded-full p-0.5 text-[10px]">
                      <FaQuestion />
                    </div>
                  </Tooltip>
                </span>
              </th>
              <th
                scope="col"
                className="px-6 py-3 sticky z-[5] bg-slate-100 left-[660px] whitespace-nowrap"
                style={{ minWidth: "150px", width: "150px" }}
              >
                Precio total
              </th>
              {NormalizeText(data?.cliente?.pais || data?.lead?.country) !== NormalizeText("Perú") && (
                <th scope="col" className="px-6 py-3">
                  Monto tipo de cambio
                </th>
              )}
              <th scope="col" className="px-6 py-3">
                Porcentaje
              </th>
              <th scope="col" className="px-6 py-3 w-56">
                <span className="flex flex-row items-center justify-center gap-4">
                  Fecha limite
                  <Tooltip content="Fecha en la que se prevee que el cliente realize el pago.">
                    <div className="bg-black text-white rounded-full p-0.5 text-[10px]">
                      <FaQuestion />
                    </div>
                  </Tooltip>
                </span>
              </th>
              <th scope="col" className="px-6 py-3 w-56">
                <span className="flex flex-row items-center justify-center gap-4">
                  Fecha pago
                  <Tooltip content="Fecha en que el cliente realizó el pago.">
                    <div className="bg-black text-white rounded-full p-0.5 text-[10px]">
                      <FaQuestion />
                    </div>
                  </Tooltip>
                </span>
              </th>
              <th scope="col" className="px-6 py-3 ">
                Banco
              </th>
              <th scope="col" className="px-6 py-3 ">
                Cuenta
              </th>
              <th scope="col" className="px-6 py-3 ">
                Pagado
              </th>
              <th scope="col" className="px-6 py-3 ">
                Imagen del pago
              </th>
              <th scope="col" className="px-6 py-3 ">
                Pago verificado
              </th>
              <th scope="col" className="px-6 py-3 ">
                Faltó al compromiso de pago
              </th>
              {hostingDomainCot && (
                <>
                  <th scope="col" className="px-6 py-3 ">
                    Agencia compró hosting
                  </th>
                  <th scope="col" className="px-6 py-3 ">
                    Agencia compró dominio
                  </th>
                  <th scope="col" className="px-6 py-3 ">
                    Agencia imagen compra dominio
                  </th>
                </>
              )}
              <th scope="col" className="px-6 py-3 ">
                Notas
              </th>
            </tr>
          </thead>
          <tbody>
          {pagosList.map((pago) => (
              <ItemRowPagoCotizacion
                key={pago.id}
                setPagosList={setPagosList}
                pagosList={pagosList}
                serviciosList={allServiciosCotizacionesList}
                data={pago}
                moneda={data.moneda}
                totalPrice={totalConIGV}
                currencyExchange={currencyExchange}
                currency={currency}
                hostingDomainCot={hostingDomainCot}
              />
            ))}

            {pagosList.length > 0 && (
              <tr className="">
                <td className="px-6 py-4 bg-white sticky left-0 z-[5] min-w-[60px] w-[60px]"></td>
                <td className="px-6 py-4"></td>
                <td className="px-6 py-4"></td>
                <td
                  className="px-6 py-4 bg-white sticky z-[5] left-[60px]"
                  style={{ minWidth: "100px", width: "100px" }}
                ></td>
                <td
                  className="px-6 py-4 bg-white sticky z-[5] left-[160px]"
                  style={{ minWidth: "500px", width: "500px" }}
                ></td>
                <td
                  className="px-6 py-4 bg-white sticky z-[5] left-[660px]"
                  style={{ minWidth: "150px", width: "150px" }}
                >
                  {" "}
                  <div
                    className={`  ${
                      pagosList.reduce((acc, obj) => acc + obj.precio, 0) ===
                        getFinalPriceCotDrawer(serviciosList, 0) &&
                      "text-green-400  flex justify-start gap-2 items-center"
                    }`}
                  >
                    {pagosList.reduce((acc, obj) => acc + obj.precio, 0) ===
                      getFinalPriceCotDrawer(serviciosList, 0) && (
                      <div>
                        <FaCheckCircle />
                      </div>
                    )}
                    <span>
                      {"S/."} {(pagosList.reduce((acc, obj) => acc + obj.precio, 0).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }))}                    
                    </span>
                  </div>
                </td>
                {NormalizeText(dataDrawer?.cliente?.pais || dataDrawer?.lead?.country) !== NormalizeText("Perú") && (
                  <td className="px-6 py-4">
                    <span className="whitespace-nowrap">
                      {(pagosList.reduce((acc, obj) => acc + obj.precio, 0) / currencyExchange).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {currency}
                    </span>
                  </td>
                )}
                <td className="px-6 py-4">
                  {" "}
                  <span>
                    {(pagosList.reduce((acc, obj) => acc + (obj.precio / totalConIGV * 100), 0).toFixed(2))}%
                  </span>
                </td>
                <td colSpan={hostingDomainCot ? 12 : 9}></td>

              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      {/* Guardar */}
      <div className=" mt-32  flex justify-center">
        <button
          type="button"
          onClick={saveAll}
          className=" max-w-lg w-full rounded-md p-2 bg-[#FF6400] hover:bg-orange-600 transition duration-500 text-white font-semibold"
        >
          Guardar
        </button>
      </div>
      
      {/* Opciones extras */}
      <div className=" flex justify-center items-center gap-4 mt-20 py-2 bg-white  shadow-xl max-w-md mx-auto w-full rounded-full">
 
        <Tooltip content=" Exportar PDF">
          <div
            onClick={() => setPdfOpen(true)}
            className=" cursor-pointer bg-orange-50 text-orange-700 hover:bg-orange-500 hover:text-white p-2 rounded-full transition duration-300"
          >
            <FaRegFilePdf />
          </div>
        </Tooltip>
   
        <Tooltip content=" Cerrar">
          <div
            onClick={onClose}
            className=" cursor-pointer bg-orange-50 text-orange-700 hover:bg-orange-500 hover:text-white p-2 rounded-full transition duration-300"
          >
            <MdClose />
          </div>
        </Tooltip>
      </div>
 
      <CotizacionPDFTestV2
        igv={igv}
        moneda={dataDrawer?.moneda}
        descuento={
          isDescuento
            ? tipoDescuento === "fijo"
              ? precioDescuento
              : (getFinalPriceCot(
                  allServiciosCotizacionesList,
                  0,
                  allServiciosList
                ) *
                  precioDescuento) /
                100
            : 0
        }
        open={pdfOpen}
        pagosList={pagosList}
        serviciosList={allServiciosCotizacionesList}
        cotizacionData={data}
        onClose={() => setPdfOpen(false)}
        title={"Vista Previa PDF"}
      />
    </DrawerRight>
  );
};

export default DrawerCotizacionCalendarioPagosDetails;

const Item = ({ title, children }) => {
  return (
    <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
      <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
        {title}
      </dt>
      <dd className=" text-xs text-gray-400">{children}</dd>
    </div>
  );
};

const ItemTransaccion = ({ title, children }) => {
  return (
    <div className="p-3 0   ">
      <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
        {title}
      </dt>
      <dd className=" text-xs text-gray-600">{children}</dd>
    </div>
  );
};
